export const OrderPaymentExports = {
  en: {
    'Payment Exports': 'Payment Exports',
    'Created At': 'Created At',
    Filename: 'Filename',
    Status: 'Status',
    Error: 'Error',
    Download: 'Download',
  },
  ru: {
    'Payment Exports': 'Экспорт платежей',
    Filename: 'Название файла',
    Status: 'Статус',
    Error: 'Ошибка',
    Download: 'Скачать',
  },
  uk: {
    'Payment Exports': 'Експорт платежів',
    'Created At': 'Дата створення',
    Filename: 'Назва файлу',
    Status: 'Статус',
    Error: 'Помилка',
    Download: 'Завантажити',
  },
};
